export default __webpack_public_path__ + "static/media/employee_skills.43efaf56.png";